import {LanguageBaseView} from "../../LanguageModel/view/LanguageBaseView";
import {CompanyValidatedBaseView} from "../../CompanyValidatedModel/view/CompanyValidatedBaseView";
import {UserGroupBaseView} from "../../UserGroupModel/view/UserGroupBaseView";
import {CountryBaseView} from "../../CountryModel/view/CountryBaseView";
import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";
import {AffiliateBaseView} from "../../AffiliateModel/view/AffiliateBaseView";

export class MemberContactView {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    language: LanguageBaseView;
    promoOptOut: boolean;
    login: LoginView;
    company: CompanyView;
    accountManagerId: number;
    accountManagerName: string;
    prefixe: number;
    invoiceMethod: number;
    invoicePeriod: number;
    function: string;
    status: number;
    purchaseOrder: string;
    paymentsOk: boolean;
    expertRole: MemberContactView_ExpertRoleView;
    paymentDueDays: number;
    telValidated: CompanyValidatedBaseView[];
    statistics: string;
    userGroup: UserGroupBaseView | null;
    blockReason: number;
    blockExtra: string;
    allowLeadRejects: boolean;
    noSuppliersPaid: number;
    refusedAffiliates: AffiliateBaseView[];

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.firstName = data?.firstName ?? "";
        this.lastName = data?.lastName ?? "";
        this.email = data?.email ?? "";
        this.language = data?.language ?? null;
        this.promoOptOut = data?.promoOptOut ?? false;
        this.login = data?.login ?? new LoginView();
        this.company = new CompanyView(data?.company) ?? null;
        this.accountManagerId = data?.accountManagerId ?? 0;
        this.accountManagerName = data?.accountManagerName ?? "";
        this.prefixe = data?.prefixe ?? 0;
        this.invoiceMethod = data?.invoiceMethod ?? 0;
        this.invoicePeriod = data?.invoicePeriod ?? 0;
        this.function = data?.function ?? "";
        this.status = data?.status ?? 0;
        this.purchaseOrder = data?.purchaseOrder ?? "";
        this.paymentsOk = data?.paymentsOk ?? false;
        this.expertRole = new MemberContactView_ExpertRoleView(data?.expertRole) ?? null;
        this.paymentDueDays = data?.paymentDueDays ?? 0;
        this.telValidated = data?.telValidated ?? [];
        this.statistics = data?.statistics ?? "";
        this.userGroup = new UserGroupBaseView(data?.userGroup) ?? null;
        this.blockReason = data?.blockReason ?? -1;
        this.blockExtra = data?.blockExtra ?? "";
        this.allowLeadRejects = data?.allowLeadRejects ?? true;
        this.noSuppliersPaid = data?.noSuppliersPaid ?? 0;
        this.refusedAffiliates = data?.refusedAffiliates?.map((affiliate: any) => new AffiliateBaseView(affiliate)) ?? [];
    }
}

class LoginView {

    id: number;
    username: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.username = data?.username ?? "";
    }
}


class CompanyView {

    id: number;
    name: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
    state: string;
    country: CountryBaseView
    regionName: string;
    phone: string;
    mobil: string;
    telValidated: CompanyValidatedBaseView[];
    website: string;
    tva: string;
    vat2Number: string;
    gln: string; // bare GLN value (Peppol scheme 0088), derived from the stored peppol identifiers
    peppolIdentifier: string; // stored Peppol identifier as "scheme:value" (scheme from DB), for editing
    vatExempted: boolean;
    logo: string;
    companyType: string;
    department: string;
    function: string;
    juridicalFormModel: JuridicalFormView;
    differentInvoiceAddress: boolean;
    officeName: string;
    officeContactPerson: string;
    officeAddress1: string;
    officeAddress2: string;
    officeCity: string;
    officeState: string;
    officeZip: string;
    officeCountry: CountryBaseView;
    industryArea: IndustryAreaView;
    dateCreation: Date;
    numberOfEmployees: number;
    bankModels: BankView[];
    faxNumber: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
        this.address1 = data?.address1 ?? ""
        this.address2 = data?.address2 ?? ""
        this.city = data?.city ?? ""
        this.zipCode = data?.zipCode ?? ""
        this.state = data?.state ?? ""
        this.country = data?.country ?? new CountryBaseView()
        this.regionName = data?.region ?? ""
        this.phone = data?.phone ?? ""
        this.mobil = data?.mobil ?? ""
        this.telValidated = data?.telValidated ?? []
        this.website = data?.website ?? ""
        this.tva = data?.tva ?? ""
        this.vat2Number = data?.vat2Number ?? ""
        this.gln = (data?.peppolIdentifiers ?? []).find((p: any) => p?.scheme === "0088")?.value ?? ""
        const storedIdentifier = (data?.peppolIdentifiers ?? [])[0]
        this.peppolIdentifier = storedIdentifier ? `${storedIdentifier.scheme}:${storedIdentifier.value}` : ""
        this.vatExempted = data?.vatExempted ?? false
        this.logo = data?.logo ?? ""
        this.companyType = data?.companyType ?? ""
        this.department = data?.department ?? ""
        this.function = data?.function ?? ""
        this.juridicalFormModel = data?.juridicalFormModel ?? ""
        this.differentInvoiceAddress = data?.differentInvoiceAddress ?? false
        this.officeName = data?.officeName ?? ""
        this.officeContactPerson = data?.officeContactPerson ?? ""
        this.officeAddress1 = data?.officeAddress1 ?? ""
        this.officeAddress2 = data?.officeAddress2 ?? ""
        this.officeCity = data?.officeCity ?? ""
        this.officeState = data?.officeState ?? ""
        this.officeZip = data?.officeZip ?? ""
        this.officeCountry = data?.officeCountry ?? new CountryBaseView()
        this.industryArea = data?.industryArea ?? new IndustryAreaView()
        this.dateCreation = data?.dateCreation ?? new Date()
        this.numberOfEmployees = data?.numberOfEmployees ?? 0
        this.bankModels = data?.bankModels?.map((bank: any) => new BankView(bank)) ?? []
        this.faxNumber = data?.faxNumber ?? ""
    }
}

class BankView {
    id: number;
    bic: string;
    iban: string;
    typeMandate: number;
    mandateId: string;
    inviteUrl: string;
    status: number | null;
    country: CountryBaseView | null;

    constructor(data: any) {
        this.id = data?.id ?? 0
        this.bic = data?.bic ?? "";
        this.iban = data?.iban ?? "";
        this.typeMandate = data?.typeMandate == -1 ? null : data?.typeMandate ?? null;
        this.mandateId = data?.mandateId ?? "";
        this.inviteUrl = data?.inviteUrl ?? "";
        this.status = data?.status == 0 ? null : data?.status ?? null;
        this.country = data?.country ? new CountryBaseView(data.country) : null;
    }
}

class IndustryAreaView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
    }
}

class JuridicalFormView {


    id: number;
    country: CountryBaseView;
    name: MessageBaseView;
    shortName: MessageBaseView;


    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.country = data?.language ?? null;
        this.name = data?.name ?? "";
        this.shortName = data?.shortName ?? "";
    }


}

export class MemberContactView_ExpertRoleView {

    id: number;
    priceSystem: number;
    dailyMaxLeads: number;
    monthlyMaxLeads: number;
    expertRegions: ExpertRegionView[];
    languages: LanguageBaseView[];
    endDateHolidaysCapping: Date;
    startDateHolidaysCapping: Date;
    expertFrees: ExpertFreeView[];
    vendor: string;
    banner: boolean;
    oldLeads: number;
    matchingOldLeads: number;
    remainingLeads: number;
    allowLeadRejects: boolean;
    protestAllowed: number;
    protestComment: string;
    discount: number;
    expertRegistrationDate: Date;
    expertActivationDate: Date;
    appearInDirectory: boolean;
    maxMonthlyProtestAllowed: number;
    noncompeteExperts: MemberContactView_ExpertRole_companyView[]
    noWeekendLeads: boolean;

    constructor(data?: any) {
        this.id = data?.id ?? -1;
        this.priceSystem = data?.priceSystem ?? -1;
        this.dailyMaxLeads = data?.dailyMaxLeads ?? -1;
        this.monthlyMaxLeads = data?.monthlyMaxLeads ?? -1;
        this.expertRegions = data?.expertRegions ?? [];
        this.languages = data?.languages ?? [];
        this.endDateHolidaysCapping = data?.endDateHolidaysCapping ?? null;
        this.startDateHolidaysCapping = data?.startDateHolidaysCapping ?? null;
        this.expertFrees = data?.expertFrees ?? [];
        this.vendor = data?.vendor ?? "";
        this.banner = data?.banner ?? false;
        this.oldLeads = data?.oldLeads ?? 0;
        this.matchingOldLeads = data?.matchingOldLeads ?? 15;
        this.remainingLeads = data?.remainingLeads ?? 0;
        this.allowLeadRejects = data?.allowLeadRejects ?? false;
        this.protestAllowed = data?.protestAllowed ?? 0;
        this.protestComment = data?.protestComment ?? "";
        this.discount = data?.discount ?? 0;
        this.expertRegistrationDate = data?.expertRegistrationDate ?? null;
        this.expertActivationDate = data?.expertActivationDate ?? null;
        this.appearInDirectory = data?.appearInDirectory ?? false;
        this.maxMonthlyProtestAllowed = data?.maxMonthlyProtestAllowed ?? -1;
        this.noncompeteExperts = data?.noncompeteExperts?.map((expert: any) => new MemberContactView_ExpertRole_companyView(expert)) ?? [];
        this.noWeekendLeads = data?.noWeekendLeads ?? false;
    }
}

class ExpertFreeView {
    id: number;
    freeLeads: number;
    status: number;
    commentFree: string;
    maxfreeMonth: number;
    dateCreation: Date;

    constructor(data?: any) {
        this.id = data?.id ?? 0
        this.freeLeads = data?.freeLeads ?? 0
        this.status = data?.status ?? 0
        this.commentFree = data?.commentFree ?? ""
        this.maxfreeMonth = data?.maxfreeMonth ?? 0
        this.dateCreation = data?.dateCreation ?? new Date()
    }
}

class ExpertRegionView {

    id: number;
    regionId: number;
    regionName: string;
    regionCountryId: number;

    constructor(data: any) {
        this.id = data?.id ?? -1;
        this.regionId = data?.regionId ?? -1;
        this.regionName = data?.regionName ?? "";
        this.regionCountryId = data?.regionCountryId ?? -1;
    }
}

class MemberContactView_ExpertRole_companyView {
    /**

     @EntityView(ExpertRoleModel.class)
      interface MemberContactView_ExpertRole_companyView {
     @IdMapping
     long getId();

     String getTelephoneNumber();

     @Mapping(value = "memberModel", fetch = FetchStrategy.SELECT)
      MemberView getMember();

     @EntityView(MemberModel.class)
      interface MemberView {
     @IdMapping
     long getId();

     @Mapping("company")
      CompanyView getCompany();

     @EntityView(CompanyModel.class)
      interface CompanyView {
     @IdMapping
     long getId();

     String getName();
     }
     }
     }
     */

    id: number;
    telephoneNumber: string;
    member: MemberContactView_ExpertRole_companyView_MemberView | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.telephoneNumber = data?.telephoneNumber ?? "";
        this.member = data?.member ? new MemberContactView_ExpertRole_companyView_MemberView(data.member) : null;
    }

}

class MemberContactView_ExpertRole_companyView_MemberView {
    id: number;
    company: MemberContactView_ExpertRole_companyView_MemberView_CompanyView | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.company = data?.company ? new MemberContactView_ExpertRole_companyView_MemberView_CompanyView(data.company) : null;
    }
}

class MemberContactView_ExpertRole_companyView_MemberView_CompanyView {
    id: number;
    name: string;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
    }
}
